import { render, staticRenderFns } from "./vendorModify.vue?vue&type=template&id=458d3e30&scoped=true"
import script from "./vendorModify.vue?vue&type=script&lang=js"
export * from "./vendorModify.vue?vue&type=script&lang=js"
import style0 from "./vendorModify.vue?vue&type=style&index=0&id=458d3e30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458d3e30",
  null
  
)

export default component.exports